import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import {
  selectGenderTypes,
  selectLanguageTypes,
} from '../../../redux/data/selectors';
import {
  getAddressInfoFields,
  getGeneralInfoFields,
  getPersonalInfoFields,
} from '../profileFieldSet';
import styles from '../styles.styl';

const mapStateToProps = state => ({
  rawGenderList: selectGenderTypes(state),
  languagesList: selectLanguageTypes(state),
});

export const enhance = compose(
  injectIntl,
  connect(mapStateToProps),
  withProps(
    ({
      rawGenderList,
      languagesList,
      profile = {},
      intl: { formatMessage },
    }) => ({
      newProp: true,
      generalInfoFields: getGeneralInfoFields(profile)(formatMessage),
      addressInfoFields: getAddressInfoFields(profile)(formatMessage),
      personalInfoFields: getPersonalInfoFields(
        profile,
        rawGenderList,
        languagesList,
      )(formatMessage),
    }),
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/PublicProfile/ProfileDetails/enhance.js